import { MdcButton, MdcBox, MdcTypography } from 'ids-wc/dist/react/components';
import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <MdcBox display="flex" direction="column" justifyContent="center" alignItems="center" className="mt-10">
          <MdcTypography text="⚠️" variant="headline1" color="textPrimary" />
          <MdcTypography text={'Something went wrong'} variant="headline5" color="textPrimary" />
          <MdcButton label={'Reload page'} className="mt-2" onClick={() => (window.location.href = '/')} />
        </MdcBox>
      );
    }

    return this.props.children;
  }
}
